import { render } from "./ClaimDetailsTabContent.vue?vue&type=template&id=4f91bdb5"
import script from "./ClaimDetailsTabContent.vue?vue&type=script&lang=js"
export * from "./ClaimDetailsTabContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__